// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.additional-unit-details .column-container {
  padding-right: 0rem;
  gap: 4rem;
}
.additional-unit-details .column-container > div {
  flex: 1 1 auto;
  max-width: 32rem;
}
.additional-unit-details .column-container h5 {
  margin-bottom: 1rem;
}
.additional-unit-details .cds--toggle__label-text {
  font-size: var(--cds-body-02-font-size, 1rem);
}
.additional-unit-details .add-row:not([disabled]) svg {
  fill: var(--cds-link-primary, #0f62fe) !important;
  color: var(--cds-link-primary, #0f62fe) !important;
}
.additional-unit-details .unit-details-pairing {
  display: grid;
  grid-template-columns: 4rem 1fr 1fr;
  grid-template-areas: "delete-btn units units" ". pecs pecs" ". host-unit host-unit";
}
.additional-unit-details .unit-details-pairing .delete-btn {
  grid-area: delete-btn;
  margin-top: 1.25rem;
  max-width: 4rem;
  height: fit-content;
}
.additional-unit-details .unit-details-pairing .delete-btn:not([disabled]) svg {
  fill: var(--cds-link-primary, #0f62fe);
  color: var(--cds-link-primary, #0f62fe);
}
.additional-unit-details .unit-details-pairing .units {
  grid-area: units;
}
.additional-unit-details .unit-details-pairing .pecs {
  grid-area: pecs;
  padding-left: 1.5rem;
}
.additional-unit-details .unit-details-pairing .host-unit {
  grid-area: host-unit;
  padding-left: 1.5rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/wizard/steps/additionalUnitDetails/AdditionalUnitDetails.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;EACA,SAAA;AAAR;AAEQ;EACI,cAAA;EACA,gBAAA;AAAZ;AAGQ;EACI,mBAAA;AADZ;AAKI;EACI,6CAAA;AAHR;AAOQ;EACI,iDAAA;EACA,kDAAA;AALZ;AASI;EACI,aAAA;EACA,mCAAA;EACA,mFACI;AARZ;AAaQ;EACI,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAXZ;AAcgB;EACI,sCAAA;EACA,uCAAA;AAZpB;AAiBQ;EACI,gBAAA;AAfZ;AAkBQ;EACI,eAAA;EACA,oBAAA;AAhBZ;AAmBQ;EACI,oBAAA;EACA,oBAAA;AAjBZ","sourcesContent":[".additional-unit-details {\n    .column-container {\n        padding-right: 0rem;\n        gap: 4rem;\n\n        &>div {\n            flex: 1 1 auto;\n            max-width: 32rem;\n        }\n\n        & h5 {\n            margin-bottom: 1rem;\n        }\n    }\n\n    .cds--toggle__label-text {\n        font-size: var(--cds-body-02-font-size, 1rem);\n    }\n\n    .add-row:not([disabled]) {\n        & svg {\n            fill: var(--cds-link-primary, #0f62fe) !important;\n            color: var(--cds-link-primary, #0f62fe) !important;\n        }\n    }\n\n    .unit-details-pairing {\n        display: grid;\n        grid-template-columns: 4rem 1fr 1fr;\n        grid-template-areas:\n            \"delete-btn units units\"\n            \". pecs pecs\"\n            \". host-unit host-unit\"\n        ;\n\n        .delete-btn {\n            grid-area: delete-btn;\n            margin-top: 1.25rem;\n            max-width: 4rem;\n            height: fit-content;\n\n            &:not([disabled]) {\n                & svg {\n                    fill: var(--cds-link-primary, #0f62fe);\n                    color: var(--cds-link-primary, #0f62fe);\n                }\n            }\n        }\n\n        .units {\n            grid-area: units;\n        }\n\n        .pecs {\n            grid-area: pecs;\n            padding-left: 1.5rem;\n        }\n\n        .host-unit {\n            grid-area: host-unit;\n            padding-left: 1.5rem;\n        }\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
